import nativeHttp from '@/utils/native/http'

interface CreateOrderOptions {
  orderSource: string // 来源,可用值:IOS_H5,ANDROID_H5,IOS,ANDROID,GOOGLE,GOOGLE_H5
  paymentChannel: 'ALIPAY' | 'WXPAY' // 支付渠道,可用值:ALIPAY,WXPAY
  productId: number
  rewardTgId: number | null // 返佣人 tgId
  productType: 'VIP' // 商品类型，固定值:VIP
  quantity: 1 // 购买数量，固定值:1
}

interface CreateOrderResponse {
  tgId: string
  orderNo: string
  productId: number
  productName: string
  productType: 'VIP'
  quantity: number
  orderAmount: number
  paymentChannel: 'WXPAY' | 'ALIPAY'
  payUrl: {
    payUrl?: string
    qrCode?: string
    urlScheme?: string
  }
}

export function createOrder(options: CreateOrderOptions): Promise<CreateOrderResponse> {
  // console.log('createOrder=====>', options)
  return nativeHttp.post('user/order/createOrder', options)
}

// const res = {
//   tgId: 5527464596,
//   orderNo: '20251218170911001',
//   productId: 36,
//   productName: 'aaron_test zh',
//   productType: 'VIP',
//   quantity: 1,
//   orderAmount: 1,
//   paymentChannel: 'WXPAY',
//   payUrl: {
//     payUrl: 'https://pay.is404.com/pay/submit/2025121817091111838/',
//   },
// }

// const res = {
//   tgId: 5527464596,
//   orderNo: '20251218172544001',
//   productId: 36,
//   productName: 'aaron_test zh',
//   productType: 'VIP',
//   quantity: 1,
//   orderAmount: 1,
//   paymentChannel: 'ALIPAY',
//   payUrl: {
//     qrCode: 'https://q.004i.cn/pay/submit/2025121817254422706/',
//   },
// }
